// Capabilities that are available in native app
enum NativeCapability {
  ViewOPD = 'ViewOPD'
}

export default NativeCapability;
